import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=4d1909a1&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=4d1909a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1909a1",
  null
  
)

export default component.exports